"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PeerNotifications = void 0;
var _react = require("react");
var _reactSdk = require("@100mslive/react-sdk");
var _ToastBatcher = require("../Toast/ToastBatcher");
var _useUISettings = require("../AppData/useUISettings");
var _constants = require("../../common/constants");
var notificationTypes = [_reactSdk.HMSNotificationTypes.PEER_LIST, _reactSdk.HMSNotificationTypes.PEER_JOINED, _reactSdk.HMSNotificationTypes.PEER_LEFT];
var PeerNotifications = function PeerNotifications() {
  var notification = (0, _reactSdk.useHMSNotifications)(notificationTypes);
  var isPeerJoinSubscribed = (0, _useUISettings.useSubscribedNotifications)(_constants.SUBSCRIBED_NOTIFICATIONS.PEER_JOINED);
  var isPeerLeftSubscribed = (0, _useUISettings.useSubscribedNotifications)(_constants.SUBSCRIBED_NOTIFICATIONS.PEER_LEFT);
  (0, _react.useEffect)(function () {
    var _notification$data;
    if (!notification) {
      return;
    }
    console.debug("[".concat(notification.type, "]"), notification);
    switch (notification.type) {
      case _reactSdk.HMSNotificationTypes.PEER_LIST:
        if (!isPeerJoinSubscribed || ((_notification$data = notification.data) === null || _notification$data === void 0 ? void 0 : _notification$data.length) === 0) {
          return;
        }
        break;
      case _reactSdk.HMSNotificationTypes.PEER_JOINED:
        if (!isPeerJoinSubscribed) {
          return;
        }
        break;
      case _reactSdk.HMSNotificationTypes.PEER_LEFT:
        if (!isPeerLeftSubscribed) {
          return;
        }
        break;
      default:
        return;
    }
    _ToastBatcher.ToastBatcher.showToast({
      notification: notification
    });
  }, [notification, isPeerJoinSubscribed, isPeerLeftSubscribed]);
  return null;
};
exports.PeerNotifications = PeerNotifications;